
import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import analytics from '@/utils/analytics';
import { toast } from "sonner";

interface TipFeedbackProps {
  tipRating: 'up' | 'down' | null;
  setTipRating: React.Dispatch<React.SetStateAction<'up' | 'down' | null>>;
  lessonDay: number;
}

const TipFeedback: React.FC<TipFeedbackProps> = ({ 
  tipRating, 
  setTipRating, 
  lessonDay 
}) => {
  const handleTipRating = (rating: 'up' | 'down') => {
    setTipRating(rating);
    
    // Track tip rating
    analytics.trackUserAction('tip_rating', { rating, lessonDay });
    
    toast.success(`Thank you for your feedback!`);
  };
  
  return (
    <div className="mt-4 flex items-center justify-between pt-2 border-t border-hormony-coral/20">
      <span className="text-sm text-hormony-charcoal/70">Was this tip helpful?</span>
      <div className="flex gap-4">
        <button 
          onClick={() => handleTipRating('up')}
          className={`flex items-center gap-1 p-1 rounded-full ${
            tipRating === 'up' ? 'text-green-500' : 'text-hormony-charcoal/50 hover:text-hormony-charcoal/80'
          }`}
        >
          <ThumbsUp size={18} />
        </button>
        <button 
          onClick={() => handleTipRating('down')}
          className={`flex items-center gap-1 p-1 rounded-full ${
            tipRating === 'down' ? 'text-red-500' : 'text-hormony-charcoal/50 hover:text-hormony-charcoal/80'
          }`}
        >
          <ThumbsDown size={18} />
        </button>
      </div>
    </div>
  );
};

export default TipFeedback;
